import { SendEmail } from '../send-email/SendEmail';

export const SendAdmitCardEmail = () => {
	return (
		<>
			<h1>Admit Card Email</h1>
			<SendEmail templateKey="EXAM_MODULE_ADMIT_CARD_EMAIL_TEMPLATE" />
		</>
	);
};
